import type { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
    html: string | '';
}

export default function HTMLRender(props: Props) {
    const { html, ...rest } = props;

    return (
        <div {...rest} dangerouslySetInnerHTML={{ __html: html }} />
    );
}